import * as React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import LytNavLinkTab from "./lytNavLinkTab";
import { PagesData, PageData } from "../interfaces";

interface PropType {
  data: PagesData;
  onChange?: Function;
}

class LytNavTabs extends React.Component<PropType> {
  state: { tabValue: number } = {
    tabValue: 0,
  };

  handleChange = (event: React.SyntheticEvent, newValue: number) => {
    this.setState(
      {
        tabValue: newValue,
      },
      () => {
        if (this.props.onChange) {
          this.props.onChange(this.props.data.pages[newValue]);
        }
      }
    );
  };

  render() {
    const BuildNavTab = (pageData: PageData) => {
      return (
        <LytNavLinkTab
          label={pageData.lable as string}
          key={`pageNav_${pageData.lable}`}
        ></LytNavLinkTab>
      );
    };

    const BuildNavTabs = () => {
      if (!this.props.data) {
        console.error("LytNavTabs didnt get data");
        return;
      }

      const navItems = this.props.data.pages.map(
        (pd: PageData, idx: Number) => {
          return BuildNavTab(pd);
        }
      );
      return navItems;
    };

    return (
      <Box sx={{ width: "100%" }}>
        <Tabs
          className="LytNavTabs"
          value={this.state.tabValue}
          onChange={this.handleChange}
          aria-label="page navigation"
          role="navigation"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          {BuildNavTabs()}
        </Tabs>
      </Box>
    );
  }
}

export default LytNavTabs;
